module.exports = __webpack_public_path__ + "img/svg/no-stars.055fc535e34af9cb3d3ef68cb6948f62.svg";